import React, { Component} from "react";
// Styles
import "./GameCompleteView.scss";


// Components
import HeaderView from "components/HeaderView";
// import Next from 'static/img/next.svg'
import  GameComplete from "views/GameComplete/GameComplete";

class GameCompleteView extends Component {

  render() {
    return (
      <>
      <div className="level-view">
      <HeaderView/>
      <GameComplete>
       </GameComplete>
    </div>
      </>
    );
  }
}
export default GameCompleteView;
